import { useEffect } from 'react';

import { differenceInMonths } from 'date-fns';

const validateDate = (streams) => {
  const currentDate = new Date();
  const MONTH_OLD = 1;
  const validDates = streams.filter(
    (stream) => differenceInMonths(currentDate, new Date(stream.timeStamp)) <= MONTH_OLD
  );
  return validDates;
};

export const useIpaEventModalControl = (
  toggleShowIpaEventJoinDetailsModal,
  streamId,
  linkQuestions,
  platformType
) => {
  const streams = JSON.parse(
    localStorage.getItem('initializedStreams') || '[]'
  );
  const isPresented = validateDate(streams)?.some(
    (str) => str.streamId === streamId
  );

  const addToInitiazedStreams = () => {
    const timeStamp = new Date().toISOString();
    const validatedStreams = validateDate(streams);
    toggleShowIpaEventJoinDetailsModal(true, true);
    localStorage.setItem(
      'initializedStreams',
      JSON.stringify([...validatedStreams, { streamId, timeStamp }])
    );
  };

  useEffect(() => {
    if (linkQuestions.length && !isPresented && platformType === 'ipa') {
      addToInitiazedStreams();
    }
  }, []);

  return {
    isPresented,
    addToInitiazedStreams
  };
};

export default useIpaEventModalControl;
